import { ComponentPropsWithoutRef } from 'react';
import { CompanyContactType } from '@api';
import { SelectField } from '@hypeit-gmbh/hypeit-ui';
import { Controller, FieldValues, useFormContext } from 'react-hook-form';
import { CompanyContactOption } from './components';
import { useCompanyContactSelect } from './hooks';

type CompanyContactSelectPropsType<T extends FieldValues> = Omit<
  ComponentPropsWithoutRef<typeof SelectField<T>>,
  'data' | 'renderOption'
> & {
  data: CompanyContactType[];
};

export const CompanyContactSelect = <T extends FieldValues>({
  data,
  ...props
}: CompanyContactSelectPropsType<T>): React.ReactNode => {
  const { control } = useFormContext<T>();
  const { contactPersonOptions, handleChange, getFieldValue } =
    useCompanyContactSelect(data);

  return (
    <Controller
      control={control}
      name={props.fieldName}
      render={({ field }) => (
        <SelectField<T>
          defaultValue={getFieldValue(field.value)}
          value={getFieldValue(field.value)}
          onChange={(value) => typeof value === 'string' ? handleChange(value, field.onChange) : null}
          {...props}
          data={contactPersonOptions}
          renderOption={(item) => (
            <CompanyContactOption label={item.option.label} />
          )}
        />
      )}
    />
  );
};
